import React, { useEffect, useState } from 'react';
import logoCentre from '../assets/images/logoCentre.PNG';
import { Link, useNavigate } from 'react-router-dom';
import CustomInput from '../components/customInput';
import CustomButton from '../components/customButton';
import { useDispatch, useSelector } from 'react-redux';
import { setUser, userSelector } from '../store/userSlice';
import getEnvironement from '../environnement';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import CustomBackdrop from '../components/backdrop';
import { setLang } from '../store/langSlice';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function login() {
    const url = `${getEnvironement().API_URL}/login`;
    const data = {
      username,
      password
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then((res) => {
        setTimeout(() => setOpenBackdrop(false), 1000);
        return res;
      })
      .then((res) => dispatch(setUser(res.data.user)))
      .then(() => navigate('/dashboard'))
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.message) {
          toast.error(err.response.data.message);
        }
      });
  }

  useEffect(() => {
    dispatch(setLang('fr'));
  }, [dispatch]);

  useEffect(() => {
    if (user !== null) {
      navigate('/dashboard');
    }
  }, [navigate, user]);

  return (
    <div className='w-full flex flex-col items-center'>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <ToastContainer />
      <div className='w-full 3xl:w-[1200px] flex justify-center'>
        <Link to='/admin'>
          <img src={logoCentre} alt='logo center' className='w-[200px]'/>
        </Link>
      </div>
      <div className='flex justify-center w-full bg-primary'>
        <div className='w-full bg-primary flex justify-between items-center px-10 3xl:px-0 3xl:w-[1200px]'>
          <p className='text-white font-inter font-semiBold text-lg'>Portail de résérvation de salle</p>
          <p className='hidden sm:inline text-white font-inter font-semiBold text-lg text-end'>Room booking portal</p>
          <p className='sm:hidden text-white font-inter font-semiBold text-lg text-end'>M.T.C</p>
        </div>
      </div>
      <div className='m-10'>
        <p className='font-inter text-primary text-center font-medium text-2xl sm:text-3xl mb-6'>Se connecter</p>
        <CustomInput
          type='text'
          placeholder={'Nom d\'utilisateur'}
          value={username}
          setValue={setUsername}
        />
        <CustomInput
          type='password'
          placeholder={'Mot de passe'}
          value={password}
          setValue={setPassword}
        />
        <CustomButton
          value='Se connecter'
          handelClick={login}
        />
        <p className='font-inter text-primary text-center font-medium text-2xl sm:text-3xl relative bottom-5 sm:bottom-0'>Bienvenue au Centre de Simulation et d'Innovation en Science de la Santé, un lieu dédié à l'excellence en formation et en recherche dans le domaine des sciences de la santé.</p>

      </div>
    </div>
  )
}
